<span kendoTooltip>
  <svg-icon title="{{ title }}" src="{{getIconUrl()}}" class="{{class}}"></svg-icon>
</span>